import gql from 'graphql-tag';
import { UTILITY_CREDENTIAL_FRAGMENT } from '../utility-sync.api';

export const GET_UTILITY_SYNC_CREDENTIAL_DATA = gql`
  query GetUtilitySyncCredentialData($utilityCredentialId: Int!) {
    utilityCredential(id: $utilityCredentialId) {
      ...UtilityCredentialData
      utility {
        id
        url
        state {
          name
          abbreviation
        }
      }
    }
  }
  ${UTILITY_CREDENTIAL_FRAGMENT}
`;

// Note this must match the limit passed to SearchUtilityAccounts;
export const SEARCH_UTILITY_ACCOUNTS_PAGINATION_LIMIT = 3;
export const SEARCH_UTILITY_ACCOUNTS = gql`
  query SearchUtilityAccounts(
    $accountId: Int!
    $utilityCredentialId: Int!
    $page: Int!
  ) {
    search {
      utilityAccounts(
        page: $page
        limit: 3
        filters: {
          accountId: $accountId
          utilityCredentialId: $utilityCredentialId
        }
      ) {
        count
        utilityAccounts {
          id
          accountNumber
          displayServiceAddress
        }
      }
    }
  }
`;

export const getUtilitySyncCredentialDataMock = {
  utilityCredential: {
    id: 234,
    type: 'UsernamePassword',
    __typename: 'UtilityCredential',
    username: 'dummy@gmail.com',
    verificationStatus: 'correct',
    utility: {
      id: 1234,
      displayName: 'Eversource NSTAR',
      overrideEmailIsUsername: false,
      url: 'www.eversource.com',
      state: {
        name: 'Massachusetts',
        abbreviation: 'MA',
      },
    },
  },
};

export const getUtilitySyncCredentialDataMockForMovers = {
  utilityCredential: {
    id: 11,
    type: 'UsernamePassword',
    __typename: 'UtilityCredential',
    username: 'dummy@gmail.com',
    verificationStatus: 'correct',
    utility: {
      id: 1234,
      displayName: 'Eversource NSTAR',
      overrideEmailIsUsername: false,
      url: 'www.eversource.com',
      state: {
        name: 'Massachusetts',
        abbreviation: 'MA',
      },
    },
  },
};

export const searchUtilityAccountsMock = {
  search: {
    utilityAccounts: {
      utilityAccounts: [
        {
          id: 2,
          accountNumber: 1,
          displayServiceAddress: '123 fake st',
        },
        {
          id: 3,
          accountNumber: 3,
          displayServiceAddress: '456 fake st',
        },
      ],
      count: 2,
    },
  },
};
